import { IWorkflowNodeOptions } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import Render from "source/app/presentation/Shared/Render";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ParseInputJSON } from "./ParseJSON/ParseInputJSON";
import { SaveNodeChangesAsync } from "../../SaveNodeChangesAsync";

export function EditNodeOptions({
    state,
    setState,
}: {
    state: IRootNodeFormState;
    setState: React.Dispatch<React.SetStateAction<IRootNodeFormState>>;
}) {
    const defaultJSON = JSON.stringify(state.newOptions);
    const [unparsedJSON, setUnparsedJSON] = React.useState<string>(defaultJSON);
    const [isValidJSON, setIsValidJSON] = React.useState<boolean>(true);

    ParseInputJSON(unparsedJSON, setState, state, setIsValidJSON);

    return (
        <div>
            <FormInput
                id="editNodeOptionsInput"
                type="text"
                onChange={(event) => setUnparsedJSON(event.target.value)}
                onEnter={async () => await SaveNodeChangesAsync()}
                maxWidth="100%"
                width="100%"
                value={unparsedJSON}
                classes={StyleClass(`editNodeOptionsStyle`, {
                    fontWeight: `bold`,
                    fontSize: `20px`,
                })}
                showEnterHint={false}
                displayBlock={true}
            />
            <Render
                id="invalidNodeOptionsJSONWarning"
                when={unparsedJSON !== `` && !isValidJSON}
            >
                <div style={{ color: `coral` }}>This is not valid JSON</div>
            </Render>
        </div>
    );
}
